import React from "react";
import { EFFECTIVE_STATE_LABELS, stateMeta } from "../constants";

export function StatusBadge({ state }) {
  const meta = stateMeta(state);
  const label = EFFECTIVE_STATE_LABELS[state] || state || "Unknown";

  return (
    <span
      className={`integrations-badge ${meta.cls} ${meta.spin ? "spinning" : ""}`}
    >
      <span className="integrations-badge-ico" aria-hidden="true">
        {meta.icon}
      </span>
      {label}
    </span>
  );
}
